import styled from 'styled-components'

export const CheckboxElement = styled.div`
  div > div {
    font-family: Navigo, Arial, Helvetica, sans-serif;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 400;
    color: #292e3d;
  }

  &:hover span {
    border-color: #a3abc2;
  }
`
